<template>
  <div id="model" :class="{ 'model-content': pid }">
    <div class="page-content" id="page-content"></div>
  </div>
</template>

<script>
export default {
  name: 'Model',
  props: {
    pid: {
      type: String,
      default: ''
    }
  },
  computed: {
    modelPid() {
      return this.$route.params.id || this.pid;
    }
  },
  data() {
    return {
      options: {
        altizureApi: {
          key: 'qwKCxUxTywiAlenHoNfhVzRuGA76O7EEYPyC4Av'
        },
        camera: {
          center: {
            alt: 217.5166400336488,
            lat: 2.8127799208015807,
            lng: 2.8122470507660475,
            north: 292.1520750526322,
            tilt: 68.32768659912247,
            up: 0
          }
        },
        renderItems: {
          earth: false,
          earthUseTexture: false,
          featureInView: false,
          orbitRing: true // 不显示初始地球的框架
        }
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initAltizure();
    });
  },
  methods: {
    initAltizure() {
      /* eslint-disable */
      this.sandbox = new altizure.Sandbox('page-content', this.options);
      window.sandbox = this.sandbox;
      this.sandbox
        .add('AltizureProjectMarker', {
          pid: this.modelPid,
          pose: {
            position: {
              lng: 2.8125,
              lat: 2.8125,
              alt: 5.198364013650895
            }
          }
        })
        .then(model => {
          model.decoHolder.visible = false; //隐藏蓝边
          model.interactable = true;
          // this.sandbox.marker.loadCropMask();
          model.on('click', e => {
            // let { x, y } = { x: e.offsetX, y: e.offsetY };
            //
            //
            // let pos = this.sandbox.window.toLngLatAlt({ x, y });
            //
          });
          return model.loadCropMask();
        })
        .catch(err => {
          //
        });
    }
  }
};
</script>

<style lang="scss">
#model {
  position: fixed;
  z-index: 2000;
  top: 0;
  #page-content {
    width: 100vw;
    height: 100vh;
  }
}
.model-content {
  position: static !important;
  #page-content {
    width: 100% !important;
  }
}
</style>
